import React from "react";
import ChallengesCard from "./ChallengesCard";
import { StyleChallengesCardSection } from "./styles";

const ChallengesCardSection = () => {
  return (
    <StyleChallengesCardSection>
      <ChallengesCard />
      <ChallengesCard />
      <ChallengesCard />
      <ChallengesCard />
      <ChallengesCard />
      <ChallengesCard />
      <ChallengesCard />
      <ChallengesCard />
    </StyleChallengesCardSection>
  );
};

export default ChallengesCardSection;
